import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Checkbox, Input, Select, Textarea } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createTableField, getDatasetsAllList } from '../../actions/datasets'


const validationSchema = Yup.object({
  dsname: Yup.string().required('обязательное поле'),
  dstranslate: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  dsdescript: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, addMode, datasetId }) {

  const dispatch = useDispatch()

  const { datasetsAllList } = useSelector(state => state.datasets)
  const [selectedField, setSelectedField] = useState([])
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getDatasetsAllList())
  }, [])

  const handleCreate = (values) => {
    dispatch(createTableField(values))
    closeModal()
  }

  const handleUpdate = (values) => {
    // dispatch(updateStudyShift(values))
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? {
      "dataset_id": datasetId,
      "linked_dataset_id": null,
      "fnum": null,
      "fname": '',
      "fdescript": null,
      "ftranslate": null,
      "ftype": '',
      "fisnull": 0,
      "fdefault": null,
      "finprimarykey": -1,
      "fisidentity": -1,
      "findesc": null
    } : data,
    enableReinitialize: true,
    validateOnChange: true,
    // validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        modal: styles.custom
      }}
    >
      <>

        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >

            <div className={styles.inputsRow}>
              {/* <SelectPal
                        title='Таблица'
                        valuesName="dsname"
                        value={values.dsname}
                        options={datasetsAllListSelect}
                        setFieldValue={setFieldValue}
                        withoutAll
                      /> */}
              <Select
                label='Поле'
                name='dsname'
                value={values.dsname}
                // error={error('rachid')}
                onChange={(e) => setFieldValue('dsname', e.target.value)}>
                <option selected={values.dsname === ''} value={''}>Выберите предмет</option>
                {/* {datasetsAllList?.map((item) => <option key={item.table_name} value={item.table_name} selected={item.table_name === values.dsname}>{item.table_name}</option>)} */}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='№ п/п'
                name='fnum'
                value={values.fnum}
                // error={error('fnum')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
              <Checkbox
                name='fisidentity'
                label='Основное описание записи'
                checked={values.fisidentity}
                onChange={() => setFieldValue('fisidentity', Number(!values.fisidentity))}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Значение'
                name='fdefault'
                value={values.fdefault}
                // error={error('fdefault')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <div className={styles.inputsColumn}>
              <p>Тип  <span>
                {values.ftype}
              </span>
              </p>
              <p>Зн. по умолчанию  <span>
                {values.fdefault}
              </span>
              </p>
              <p>Обязательное <span>
                {values.findesc}
              </span>
              </p>
              <p>Первичный ключ  <span>
                {values.finprimarykey}
              </span>
              </p>
              <p>Автоинкремент <span>
                {values.fdescript}
              </span>
              </p>
            </div>
            <div className={styles.inputsRow}>
              <Select
                label='Ссылки на таблицу'
                name='dsname'
                value={values.dsname}
                // error={error('rachid')}
                onChange={(e) => setFieldValue('dsname', e.target.value)}>
                <option selected={values.dsname === ''} value={''}>Выберите предмет</option>
                {datasetsAllList?.map((item) => <option key={item.table_name} value={item.table_name} selected={item.table_name === values.dsname}>{item.table_name}</option>)}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Textarea
                label='Подробное описание'
                name='dsdescript'
                value={values.dsdescript}
                error={error('dsdescript')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>

          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
